import React, { Fragment } from "react";
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Event from '@mui/icons-material/Event';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

// Form values are ISO strings (see the date field `normalize`); x-date-pickers only accepts moment objects or null.
const toMoment = (value: any): Moment | null => {
  if (!value) {
    return null;
  }
  return moment.isMoment(value) ? value : moment(value, [moment.ISO_8601, 'MM-DD-YYYY']);
};

export const DateInput = (props) => {
  const { meta, input } = props;
  const { touched, error } = meta;
  const { onBlur, onChange, value } = input;
  const shouldShowError = touched && !!error;

  const { t } = useTranslation();

  return (
    <Fragment>
      <DesktopDatePicker
        format     = "MM-DD-YYYY"
        label      = {props.label}
        localeText = {{
          cancelButtonLabel: t('button.datePicker.cancel', { defaultValue: 'Cancel' }),
          okButtonLabel    : t('button.datePicker.submit', { defaultValue: 'OK' }),
        }}
        onChange   = {(value: Moment | null) => {
          if (value?.isValid()) {
            value.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
          }
          onChange(value);
        }}
        slots      = {{
          leftArrowIcon : KeyboardArrowLeft,
          openPickerIcon: Event,
          rightArrowIcon: KeyboardArrowRight,
        }}
        slotProps  = {{
          // Match the v4 KeyboardDatePicker icon button: 48px with 12px padding, inside the field edge.
          openPickerButton: {
            edge: false,
            sx  : { padding: '12px' },
          },
          textField: {
            error     : shouldShowError,
            fullWidth : true,
            helperText: touched && error,
            // Only mark the field touched. The value comes from the picker's onChange (a moment, or an invalid
            // moment while partly typed); the field's text is the "MM-DD-YYYY" placeholder when empty, so passing
            // the blur event would store that text, or a guessed date for partly typed input.
            onBlur    : () => onBlur(),
            onFocus   : props.input.onFocus,
            variant   : 'standard',
          },
        }}
        value      = {toMoment(value)}
        {...props.datePickerProps}
      />
    </Fragment>
  );
};
